// theme
import palette from './palette';

// ----------------------------------------------------------------------

const INK = palette.light.pixelInk;

// Hard, non-blurred offset shadow — the pixel-art "drop shadow" look.
// Offset steps up with elevation, capped at 8px so high elevations
// (dialogs, popovers) don't produce absurdly large shadows.
const pixelOffset = (elevation) => Math.min(2 + Math.floor((elevation - 1) / 4) * 2, 8);

const createShadow = () =>
  Array.from({ length: 25 }, (_, elevation) => {
    if (elevation === 0) return 'none';
    const offset = pixelOffset(elevation);
    return `${offset}px ${offset}px 0px 0px ${INK}`;
  });

const createCustomShadow = () => ({
  z1: `2px 2px 0px 0px ${INK}`,
  z8: `4px 4px 0px 0px ${INK}`,
  z12: `4px 4px 0px 0px ${INK}`,
  z16: `6px 6px 0px 0px ${INK}`,
  z20: `6px 6px 0px 0px ${INK}`,
  z24: `8px 8px 0px 0px ${INK}`,
  primary: `4px 4px 0px 0px ${palette.light.primary.dark}`,
  secondary: `4px 4px 0px 0px ${palette.light.secondary.dark}`,
  info: `4px 4px 0px 0px ${palette.light.info.dark}`,
  success: `4px 4px 0px 0px ${palette.light.success.dark}`,
  warning: `4px 4px 0px 0px ${palette.light.warning.dark}`,
  error: `4px 4px 0px 0px ${palette.light.error.dark}`
});

export const customShadows = {
  light: createCustomShadow(),
  dark: createCustomShadow()
};

const shadows = {
  light: createShadow(),
  dark: createShadow()
};

export default shadows;
